import { hasPermission } from '@/hooks/useBackendMenu'
import Dialog from 'global/guides/Dialog'
import { useNavigate, useParams } from 'react-router-dom'
import { trocaHorario } from 'service/api'
import { FormTrocaDiaTrabalho } from '../forms/TrocaDiaTrabalho'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

export default function DetalhesTrocaDia() {
    const navigate = useNavigate()

    const params = useParams<{ id: string }>()

    const { data } = trocaHorario.diaTrabalho.useFetchById(params.id!, {
        onSuccess: troca => {
            if (!troca) navigate(-1)
        },
    })

    const { mutate, isLoading } = trocaHorario.diaTrabalho.mutations.useDelete({
        onSuccess: () => {
            invalidateDigitacaoQueries()
            navigate(-1)
        },
    })

    if (!data) return null

    return (
        <Dialog.Root
            height="auto"
            onSubmit={
                hasPermission(['delete', 'TrocaDeDiaDeTrabalho'])
                    ? () => mutate(+params.id!)
                    : undefined
            }
            loading={isLoading}
            defaultValues={{
                ...data,
            }}
            disableFields
        >
            <Dialog.Title>Detalhes da troca de dia de trabalho</Dialog.Title>
            <Dialog.Content dividers>
                <FormTrocaDiaTrabalho disableSelects disabled />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Voltar
                </Dialog.Actions.SecondaryButton>
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
